function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0.354797 11.0078L5.06888 6.49394L0.354797 1.98007C0.242312 1.87237 0.153085 1.7445 0.0922094 1.60378C0.0313333 1.46305 1.18522e-09 1.31222 0 1.1599C-1.18521e-09 1.00758 0.0313333 0.856752 0.0922094 0.716026C0.153085 0.575301 0.242312 0.447434 0.354797 0.339727C0.467281 0.232021 0.600819 0.146583 0.747787 0.0882924C0.894755 0.030002 1.05227 -1.13487e-09 1.21135 0C1.37043 1.13488e-09 1.52795 0.030002 1.67491 0.0882924C1.82188 0.146583 1.95542 0.232021 2.06791 0.339727L7.64462 5.67958C8.11846 6.13329 8.11846 6.86622 7.64462 7.31993L2.06791 12.6598C1.9555 12.7676 1.82199 12.8532 1.67501 12.9116C1.52803 12.97 1.37047 13 1.21135 13C1.05223 13 0.894668 12.97 0.747689 12.9116C0.60071 12.8532 0.467198 12.7676 0.354797 12.6598C-0.106892 12.2061 -0.119042 11.4615 0.354797 11.0078Z",
  fill: "#2E7AE2"
});

var SvgArrowRight = function SvgArrowRight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgArrowRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow_right.46c6fe39.svg";
export { ForwardRef as ReactComponent };